import { invariant } from 'utils/invariant'

const lfsUrl = process.env.NEXT_PUBLIC_LFS_URL ?? process.env.VITE_LFS_URL
invariant(lfsUrl, 'NEXT_PUBLIC_LFS_URL is required within @repo/web-utils/env')

export const LFS_URL = lfsUrl
